import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { useSettingParams } from '../../../common/filterCompany/useSettingParams'
import { UseTimeZone } from '../../../common/hooks/useTimeZone'
import { SelectCustom } from '../../../common/selectCustom'
import { Separator } from '../../../common/separator'
import { FORMAT, formatDateTime } from '../../../helpers/datetime'
import { EMPTY_VALUE } from '../../../utils/common'
import { PERIOD, getPeriodValueFromNumberValue } from '../constant'
import { changePeriod, selectMaxDate, selectPeriod } from './slice'
import { getMaxDate } from './thunk'

export const Period = () => {
  const dispatch = useDispatch()

  const locale = useSelector((state) => state.i18n.locale)
  const timezone = UseTimeZone()
  const settingParams = useSettingParams()
  const maxDate = useSelector(selectMaxDate)
  const period = useSelector(selectPeriod)

  const isFixedPeriod = [
    'CurrentCreditRiskScore',
    'CurrentPerformanceScore',
    'PreviousCreditRiskScore',
    'PreviousPerformanceScore',
  ].some((key) => {
    if (!settingParams) return false
    const listCustomRanges =
      settingParams.scoreLevel[key]?.ListCustomRanges || []
    const listLevelScoreChecked =
      settingParams.scoreLevel[key]?.ListLevelScoreChecked || []
    return (
      !!listLevelScoreChecked.length ||
      listCustomRanges.some((item) => !!item.From || !!item.To)
    )
  })

  const handleChangePeriod = ({ value }) => {
    dispatch(changePeriod(value))
  }

  useEffect(() => {
    if (isFixedPeriod) {
      dispatch(
        changePeriod(
          getPeriodValueFromNumberValue(settingParams.scoreLevel.PeriodType),
        ),
      )
    }
  }, [isFixedPeriod, settingParams])

  useEffect(() => {
    if (!settingParams) return
    dispatch(getMaxDate(settingParams))
  }, [settingParams])

  const formatMaxDate = () => {
    if (!Object.keys(maxDate).length) return EMPTY_VALUE
    const { year, month, day } = maxDate
    return formatDateTime(
      new Date(year, month - 1, day),
      FORMAT.DATE,
      locale,
      timezone,
    )
  }

  const dataSelect = Object.values(PERIOD).map((i) => ({
    ...i,
    disabled:
      isFixedPeriod && i.numberValue !== settingParams?.scoreLevel?.PeriodType,
  }))

  return (
    <div className="dFlex alignItemsCenter fw600">
      <div>
        <Translate value="portfolio.common.LAST_UPDATE_DATE" />:{' '}
        <span>{formatMaxDate()}</span>
      </div>
      <Separator
        width={1}
        height={18}
        backgroundColor={'#9C9C9C'}
        margin="0 10px"
      />
      <div className="mr1">
        <Translate value="portfolio.common.PERIOD" />:
      </div>
      <SelectCustom
        activeItem={{ value: period }}
        isI18n
        data={dataSelect}
        style={{ color: '#3A414B' }}
        chooseItem={handleChangePeriod}
      />
    </div>
  )
}
